import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { type LayoutProps, PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'

export const pageUrl = '/[locale]/fundraising-events/[slug]/manage/projects'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl.bind(null, true))
export type ProjectsPageProps = PageProps<typeof pageUrl>
export type ProjectsLayoutProps = LayoutProps<typeof pageUrl, 'modal' | 'selected'>
